// components/Auth/LogoHeader.js
// components/AuthPage/PicProfileLogo.jsx

export default function LogoHeader() {
  return (
    <div className="flex flex-col items-center mb-7">

      {/* ── Whale logo ── */}
      <div className="mb-3" style={{ filter: "drop-shadow(0 0 7px rgba(59,130,246,0.45))" }}>
        <img
          src={`${process.env.PUBLIC_URL}/whale.png`}
          alt="PicProfile logo"
          width={46}
          height={46}
          style={{ objectFit: "contain" }}
        />
      </div>

      {/* ── Wordmark — Orbitron = geometric segmented font matching sketch ── */}
      {/* Add to index.html: <link href="https://fonts.googleapis.com/css2?family=Orbitron:wght@600&display=swap" rel="stylesheet"/> */}
      <span
        className="uppercase tracking-[0.18em] text-xl font-semibold"
        style={{
          fontFamily: "'Orbitron', sans-serif",
          background: "linear-gradient(120deg, #93c5fd, #e2e8f0 50%, #67e8f9)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        PicProfile
      </span>

     
    </div>
  );
}